import React from 'react';

const DailyWordCell = ({ word, isVisible, isArmed, onToggle }) => {
  const normalizedWord = typeof word === 'string' ? word.trim() : '';
  if (!normalizedWord) return '-';

  const title = isVisible
    ? 'Click to hide word'
    : isArmed
      ? 'Click again to reveal word'
      : 'Click once to prepare reveal';

  return (
    <button
      type="button"
      className={`daily-admin-word-toggle${isVisible ? ' is-revealed' : ''}${isArmed ? ' is-armed' : ''}`}
      onClick={onToggle}
      title={title}
      aria-label={title}
    >
      {isVisible ? normalizedWord.toUpperCase() : isArmed ? 'Click again to reveal' : 'Hidden'}
    </button>
  );
};

export default DailyWordCell;

